import clsx from "clsx";
import { type FC, useCallback, useState } from "react";
import { postEmbedTrack } from "../../libs/client/embedTracking";

type Props = {
  code: string;
  /** クーポンのシリーズ (計測のラベル) */
  series: string;
};

export const CouponPage: FC<Props> = ({ code, series }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    // 計測は親ページが行う (このページは iframe で埋められ、自分では GA を読み込まない)。
    // 押したことを数えるので、クリップボードへの書き込みの成否を待たない
    postEmbedTrack("coupon_copy", series);
    // 埋め込み先がクリップボードを許していない (書き込みが失敗する)・Clipboard API が無い (undefined) 等。
    // どちらでもコードは画面に出ているので、手で写せる
    navigator.clipboard
      ?.writeText(code)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
      })
      .catch(() => {});
  }, [code, series]);

  return (
    <div className="flex select-none items-center justify-center">
      {/* 画像の下半分は無地の余白なので、コードの欄が収まるところで切る (601×820)。
          埋め込み側の iframe もこの縦横比にする。
          FIXME: Figma の LP の iframe 部品の style はまだ aspect-ratio: 601/1041 のまま (下に透明な空きが残る) */}
      <div className="relative aspect-601/820 w-[601px] max-w-full overflow-hidden">
        <img
          className="block h-full w-full object-cover object-top"
          src="/banners/coupons/260129.png"
          alt="Coupon Banner"
          width="601"
          height="1041"
        />
        <div className="absolute top-[66%] right-5 bottom-0 left-5 flex flex-col items-center justify-center gap-2">
          <span className="font-bold text-2xl text-white">クーポンコード</span>
          <button
            type="button"
            onClick={handleCopy}
            className="w-full cursor-pointer select-text rounded border-2 border-gray-800 border-dashed bg-white/90 px-12 py-4 text-center font-bold text-4xl text-gray-800 tracking-widest transition-transform duration-100 active:scale-[0.98]"
          >
            {code}
          </button>
          <div
            className={clsx(
              "fixed top-5 left-1/2 z-1000 -translate-x-1/2 whitespace-nowrap rounded-lg bg-gray-800 px-6 py-4 text-center text-sm text-white leading-relaxed shadow-lg transition-all duration-300",
              copied ? "visible opacity-100" : "invisible opacity-0",
            )}
          >
            コピーしました！
            <br />
            決済画面でご入力ください
          </div>
        </div>
      </div>
    </div>
  );
};
